import React, {useCallback, useEffect, useState} from 'react';
import {DataGrid, GridOverlay, GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import {getStickeringAssets} from '../../services/asset.service';
import Box from '@mui/material/Box';
import * as CryptoJS from "crypto-js";
import StickerPasteStatusPopupBox from "../../atoms/StickerPasteStatusPopupBox";
import {Pagination} from "@mui/material";
import Select from "react-select";
import '../ExcelUploads/AssetInfo/AssetList.css';
import '../ExcelUploads/AssetInfo/DataGridStyles.css';

/* ─── Date Helpers (unchanged) ─── */
Date.prototype.dbFormatedDate = function () {
    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    return year + '-' + month + '-' + day;
}

function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport 
                csvOptions={{
                    fileName: 'Stickering_Status_List',
                }}
            />
        </GridToolbarContainer>
    );
}

const CustomLoader = () => (
    <GridOverlay>
        <CircularProgress color="primary" size={30}/>
    </GridOverlay>
);

function StickeringStatusList() {
    /* ─── All State (unchanged) ─── */
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [tag, setTag] = useState('');
    const [qrPasteStatus, setQrPasteStatus] = useState('');
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    /* ─── Columns (backend unchanged – enhanced styling) ─── */
    const columns = [
        {field: "sl_no", hideable: true, hide: true, editable: false, headerName: "Sl No", width: 50},
        {
            field: "tag", editable: false, hide: false, headerName: "TAG", width: 250,
            renderCell: (params) => {
                let EncryptID = CryptoJS.AES.encrypt(JSON.stringify({
                    'tag': params.row.tag, 'back_url': 'stickering-status'
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                return <a className="al-cell-tag-link" href={`/asset-basic-details?tag=${EncryptID}`}><i className="bi bi-tag-fill"></i> {params.value}</a>;
            }
        },
        {field: "parent_tag", hideable: true, hide: false, editable: true, headerName: "Parent TAG", width: 250},
        {
            field: "qr_paste_status", editable: true, hide: false, headerName: "Status of QR Sticker", width: 230,
            renderCell: (params) => {
                const isPasted = params.row.qr_paste_status !== 'N';
                return (
                    <div
                        className={`al-status-badge ${isPasted ? 'al-status-success' : 'al-status-danger'} al-status-clickable`}
                        onClick={() => handleConfirmOpen(params.row.qr_paste_status, params.row.tag)}
                    >
                        <i className={`bi ${isPasted ? 'bi-check-circle-fill' : 'bi-x-circle-fill'}`}/>
                        {isPasted ? 'Pasted' : 'Not Pasted'}
                    </div>
                );
            }
        },
        {
            field: "created_at", editable: true, hide: false, headerName: "Date of Addition", width: 150,
            renderCell: (params) => <p>{getFormatedDate(params.row.created_at)}</p>
        },
    ];

    const calculateOffset = (page, pageSize) => (page - 1) * pageSize;

    /* ─── Fetch Assets (unchanged logic) ─── */
    const fetchAssets = useCallback(async () => {
        setLoading(true);
        const offset = calculateOffset(page, pageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {'offset': offset, 'pageSize': pageSize},
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        try {
            const res = await getStickeringAssets({token: encryptedData});
            if (res?.data?.data?.length) {
                setItems(res.data.data);
                setTotalItems(res.data.total || 0);
            } else {
                setItems('');
            }
        } catch (error) {
            console.error('Error fetching assets:', error);
        } finally {
            setLoading(false);
        }
    }, [page, pageSize]);

    useEffect(() => {
        fetchAssets();
    }, [fetchAssets]);

    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setPage(1);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const totalPages = Math.ceil(totalItems / pageSize);

    const handleConfirmClose = () => {
        fetchAssets();
        setIsConfirmOpen(false);
    };

    const handleConfirmOpen = async (qr_paste_status, tag) => {
        setQrPasteStatus(qr_paste_status);
        setTag(tag);
        setIsConfirmOpen(true);
    };

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="stickering-status-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-qr-code-scan"/>
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Stickering Status List</h5>
                        <p className="al-page-subtitle">Track QR sticker application status for assets</p>
                    </div>
                </div>
                {!loading && items.length > 0 && (
                    <div className="al-record-badge" id="al-record-badge">
                        <i className="bi bi-layers-fill"/>
                        <strong>{totalItems.toLocaleString('en-IN')}</strong>&nbsp;Total Assets
                    </div>
                )}
            </div>

            {/* ══ DATA GRID CARD ══ */}
            <div className="al-grid-card" id="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-table"/> Stickering Records
                    </span>
                    {!loading && items.length > 0 && (
                        <span className="al-showing-badge">
                            Showing <strong>{items.length}</strong> of <strong>{totalItems.toLocaleString('en-IN')}</strong>
                        </span>
                    )}
                </div>

                <Box>
                    <DataGrid
                        rows={items}
                        getRowId={(row) => row.tag}
                        columns={columns}
                        autoHeight
                        className="al-data-grid"
                        components={{
                            LoadingOverlay: CustomLoader,
                            Toolbar: CustomToolbar,
                            Pagination: () => (
                                <Box className="al-pagination-bar">
                                    <div className="al-page-size-row">
                                        <span className="al-page-size-label">Rows per page</span>
                                        <Select
                                            options={[
                                                {value: 50, label: '50'},
                                                {value: 100, label: '100'},
                                                {value: 200, label: '200'},
                                                {value: 500, label: '500'},
                                            ]}
                                            value={{value: pageSize, label: pageSize.toString()}}
                                            onChange={(selected) => handlePageSizeChange(selected.value)}
                                            classNamePrefix="al-select"
                                            menuPlacement="top"
                                            styles={{container: (base) => ({...base, minWidth: 80})}}
                                        />
                                    </div>
                                    <Pagination
                                        count={totalPages}
                                        page={page}
                                        onChange={handlePageChange}
                                        variant="outlined"
                                        shape="rounded"
                                        size="small"
                                    />
                                </Box>
                            ),
                        }}
                        loading={loading}
                    />
                </Box>
            </div>

            {/* ══ STICKER STATUS MODAL (unchanged) ══ */}
            <StickerPasteStatusPopupBox
                qrPasteStatus={qrPasteStatus}
                tag={tag}
                isOpen={isConfirmOpen}
                onClose={handleConfirmClose}
            />
        </div>
    )
}

export default StickeringStatusList